'use strict'

import format from 'string-format'
import {obj_to_FormData} from "./utils";

export default class ProjectsApi {
	constructor(session) {
		this._session = session
	}

	get session() {
		return this._session
	}

	project_list() {
		return this.session.get('project/')
	}

	project_create(project, details = true) {
		// TODO: details не используется
		let data = obj_to_FormData(project)

		return this.session.request({
			method: 'CREATE',
			url: 'project/',
			headers: {'Content-Type': 'multipart/form-data',},
			data
		})
	}

	project_update(project, details = true) {
		// TODO: details не используется
		let data = obj_to_FormData(project)

		return this.session.request({
			method: 'PATCH',
			url: format('project/{id}', {id: project.id}),
			headers: {'Content-Type': 'multipart/form-data'},
			data
		})
	}
}